import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/GIF_ester.gif'


const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "about__photo container-width" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "about__photo-img",
    alt: "404",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "about__place container-width" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "Donde encontrarnos?", -1)
const _hoisted_5 = { class: "about__place-columns" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "about__place-map" }, [
  /*#__PURE__*/_createVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d748.0339946926139!2d2.1763597292512884!3d41.414566804455866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a3fddd4be7ad%3A0x57f4a94cd25a1bca!2sCou%20ceramica!5e0!3m2!1sen!2ses!4v1631281842923!5m2!1sen!2ses",
    width: "100%",
    height: "400",
    style: {"border":"0","max-height":"80vh"},
    allow: "fullscreen",
    loading: "lazy"
  })
], -1)
const _hoisted_7 = { class: "about__place-list" }
const _hoisted_8 = { class: "about__place-list__item" }
const _hoisted_9 = { class: "about__place-list__item" }
const _hoisted_10 = { class: "about__place-list__item" }
const _hoisted_11 = { class: "about__place-list__item" }
const _hoisted_12 = { class: "about__place-list__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("ul", _hoisted_7, [
          _createVNode("li", _hoisted_8, [
            _createVNode(_component_Button, {
              icon: "map-marker",
              href: "https://goo.gl/maps/ofWaZAFXCWGJ6dAt8",
              theme: "text",
              title: "Direccion",
              text: "Carrer del Trobador, 1, Barcelona"
            })
          ]),
          _createVNode("li", _hoisted_9, [
            _createVNode(_component_Button, {
              icon: "envelope",
              href: "mailto:info@couceramica.com",
              theme: "text",
              title: "Email",
              text: "info@couceramica.com"
            })
          ]),
          _createVNode("li", _hoisted_10, [
            _createVNode(_component_Button, {
              icon: "instagram",
              href: "https://www.instagram.com/the.little.pot/",
              theme: "text",
              title: "The Little Pot",
              text: "@the.little.pot"
            })
          ]),
          _createVNode("li", _hoisted_11, [
            _createVNode(_component_Button, {
              icon: "instagram",
              href: "https://www.instagram.com/couceramica/",
              theme: "text",
              title: "Cou Ceramica",
              text: "@couceramica"
            })
          ]),
          _createVNode("li", _hoisted_12, [
            _createVNode(_component_Button, {
              icon: "etsy",
              href: "https://www.etsy.com/es/shop/thelittlepotceramics",
              theme: "text",
              title: "Etsy",
              text: "Etsy"
            })
          ])
        ])
      ])
    ])
  ]))
}